import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { SplitterModule } from 'primeng/splitter';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SanitizerUrlPipe } from '../../utils/pipes/sanitizer-url.pipe';
import { MainContent } from '../../services/main-content.service';
import { Subject, takeUntil } from 'rxjs';
import { TabsModule } from 'primeng/tabs';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgxSignaturePadModule, NgxSignaturePadComponent } from '@eve-sama/ngx-signature-pad';
import { ActionsService } from '../../services/actions.service';
import { DateFormatService } from '../../services/dateformat.service';
import { StatusService } from '../../services/status.service';
import { DomainInfo } from '../../models/domainInfo/domainInfo.model';
import { DialogService } from '../../shared/services/dialog.service';




const SIGN_TYPE = 'Sign';


@Component({
    selector: 'signing-screen',
    imports: [
        SplitterModule,
        CommonModule,
        SanitizerUrlPipe,
        TabsModule,
        TranslateModule,
        MatIconModule,
        NgxSignaturePadModule,
        TooltipModule,
        FormsModule,


    ],
    templateUrl: './signing-screen.html',
    styleUrl: './signing-screen.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SigningScreenComponent implements OnInit, OnDestroy {
    viewURL: string = '';
    selectedFileKey: string = '';
    // Blob URLs of the Google files already loaded through the proxy, by file id
    private googleBlobUrls = new Map<string, string>();
    // Ids of the Google files being loaded through the proxy
    private googleLoading = new Set<string>();
    // The loaded files themselves (and the name the proxy gave them), so downloading one needs no new request
    private googleFiles = new Map<string, { blob: Blob; name: string | null }>();
    // Ids of the Google files being downloaded
    private downloading = new Set<string>();
    downloadUrl: string = '';
    files: any[] = [];
    @Input() downloadId: string = '';
    @Output() tokenError = new EventEmitter<{ status: number }>();
    sharedBy: string = '';
    status: string = '';
    expirationDate: string = '';
    summary: string = '';
    subject: string = '';
    private destroy$ = new Subject<void>();
    activeTab: string = 'signing';
    accesses: any[] = [];
    showSignaturePad: boolean = false;
    comment: string = '';

    viewedFiles: Set<string> = new Set();
    allFilesViewed: boolean = false;

    user: string = '';
    userSigned: boolean = false;
    userStatus: string = '';
    type: string = 'Download';
    isLoading: boolean = true;

    domainInfo: DomainInfo | null = null;

    @ViewChild('signaturePad', { static: false }) signaturePad!: NgxSignaturePadComponent;

    options = {
        minWidth: 1,
        maxWidth: 3,
        backgroundColor: 'white',
        penColor: 'darkblue',
        canvasWidth: '100%',
        canvasHeight: '100%',
        height: 205,
        width: 400
    };


    short24: string;
    userSignatureDate: string = '';
    userSignatureBase64: string = '';
    userComment: string = '';

    panelSizes: number[] = [20, 80];

    device: string = '';
    currentFileIndex: number = 0;
    showSignatureView: boolean = false;
    fullAccess: boolean = false;
    enabled: boolean = true;
    idUser: string = '';
    isOwner: boolean = false;
    role: string | null = null;
    isSubmitting: boolean = false;

    constructor(
        private mainContentService: MainContent,
        private cdr: ChangeDetectorRef,
        private translate: TranslateService,
        private actionsService: ActionsService,
        private dateFormatService: DateFormatService,
        private statusService: StatusService,
        private dialogService: DialogService
    ) {
        this.short24 = this.dateFormatService.short24;
    }

    ngOnInit(): void {
        this.checkScreenSize();

        this.statusService.devices$.subscribe((device) => {
            this.device = device;
        });

        this.loadFiles();

    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.checkScreenSize();
    }

    checkScreenSize() {
        const width = window.innerWidth;

        if (width < 768) {
            let newHeight = 373;
            let newWidth = 410;

            this.options = {
                ...this.options,
                height: newHeight,
                width: newWidth
            }

            this.panelSizes = [40, 60];
        } else if (width < 1500) {
            this.panelSizes = [30, 70];
        } else {
            this.panelSizes = [20, 80];
        }
    }

    scrollToSignature(): void {
        this.showSignatureView = true;
    }

    scrollToTop(): void {
        this.activeTab = 'signing';
        const container = document.querySelector('.container');
        if (container) {
            container.scrollTo({ top: 0, behavior: 'smooth' });
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    previousFile(): void {
        if (this.userSigned && this.type === SIGN_TYPE) {
            if (this.showSignatureView) {
                return;
            }
            if (this.currentFileIndex > 0) {
                this.currentFileIndex--;
                this.onFileSelected(this.files[this.currentFileIndex]);
            } else {
                this.showSignatureView = true;
            }
        } else {
            if (this.showSignatureView) {
                this.showSignatureView = false;
                return;
            }
            if (this.currentFileIndex > 0) {
                this.currentFileIndex--;
                this.onFileSelected(this.files[this.currentFileIndex]);
            }
        }
    }

    nextFile(): void {
        if (this.userSigned && this.type === SIGN_TYPE && this.showSignatureView) {
            this.showSignatureView = false;
            this.currentFileIndex = 0;
            this.onFileSelected(this.files[this.currentFileIndex]);
            return;
        }

        if (this.currentFileIndex < this.files.length - 1) {
            this.currentFileIndex++;
            this.onFileSelected(this.files[this.currentFileIndex]);
        }
    }


    loadFiles(): void {

        if (this.downloadId) {
            this.mainContentService.viewDownload(this.downloadId)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (fileResponse: any) => {
                        if (!fileResponse || Object.keys(fileResponse).length === 0) {
                            sessionStorage.removeItem('authToken');
                            this.tokenError.emit({ status: 403 });
                            return;
                        }
                        this.status = fileResponse.signStatus || null;
                        this.sharedBy = fileResponse.user;
                        this.expirationDate = fileResponse.expirationDate;
                        this.subject = fileResponse.subject;
                        this.summary = fileResponse.summary;
                        this.files = fileResponse.files || [];
                        this.accesses = this.processAccessesSignatures(fileResponse.accesses || []);
                        this.showSignaturePad = fileResponse.signaturePad || false;
                        this.type = fileResponse.type || 'Download';
                        this.isLoading = false;
                        this.enabled = fileResponse.enabled;
                        this.role = fileResponse.viewerRole || null;

                        if (this.role === 'OWNER') {
                            this.isOwner = true;
                        }

                        if (this.files.length > 0) {
                            // The first file is requested first; the rest load in parallel behind it
                            this.onFileSelected(this.files[0]);
                            this.preloadGoogleFiles();
                        }

                        if (this.sharedBy === this.idUser) {
                            this.isOwner = true;
                        }

                        this.checkIfUserSigned();

                        if (this.userSigned && this.device === 'mobile' && this.type === SIGN_TYPE && !this.isOwner) {
                            this.showSignatureView = true;
                        }

                        this.mainContentService.getDomainInfo(fileResponse.namespace)
                            .subscribe({
                                next: (response: DomainInfo) => {
                                    this.domainInfo = response;
                                },
                                error: (error: any) => {
                                    console.error('Error loading domain info:', error);
                                }
                            });

                        this.cdr.detectChanges();
                    },
                    error: (error: any) => {
                        console.error('Error loading files:', error);
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        if (error.status === 401 || error.status === 403) {
                            sessionStorage.removeItem('authToken');
                            this.tokenError.emit({ status: error.status });
                        }
                    }
                });
        }

    }

    private processAccessesSignatures(accesses: any[]): any[] {
        return accesses.map(access => ({
            ...access,
            signatureBase64: access.signatureBase64
                ? this.formatBase64Image(access.signatureBase64)
                : null
        }));
    }

    private formatBase64Image(base64: string): string {
        if (!base64) return '';
        if (base64.startsWith('data:')) return base64;
        return `data:image/png;base64,${base64}`;
    }

    shouldShowButtons(): boolean {
        return !this.isLoading && this.userSigned && this.type === SIGN_TYPE;
    }

    isGoogleFile(file: any): boolean {
        return !!file.protectedPreviewLink?.includes('google.com');
    }

    // Office: webViewLink is the embeddable embed.aspx URL (protectedPreviewLink is the plain SharePoint URL, needs login).
    // Google files are not embedded from a link: they go through the download proxy (see loadGoogleFile).
    getPreviewUrl(file: any): string {
        return file.webViewLink || file.protectedPreviewLink;
    }

    // Id of the file in the Download. The proxy asks officeware, which also accepts the Drive id.
    private fileRef(file: any): string {
        return file.fileId || file.id;
    }

    onFileSelected(file: any): void {
        this.selectedFileKey = this.fileRef(file);

        if (this.isGoogleFile(file)) {
            this.loadGoogleFile(file);
        } else {
            this.viewURL = this.getPreviewUrl(file);
        }
        this.downloadUrl = file.webContentLink || file.downloadLink;

        const fileId = file.id || file.webViewLink;
        this.viewedFiles.add(fileId);

        this.checkAllFilesViewed();
    }

    // Shows a Google file: the one already loaded, or the one being loaded (it is shown when it arrives).
    private loadGoogleFile(file: any): void {
        const cached = this.googleBlobUrls.get(this.fileRef(file));
        if (cached) {
            this.viewURL = cached;
            return;
        }

        this.viewURL = '';
        this.fetchGoogleFile(file);
    }

    // The user has to read every file before signing, so all of them are requested up front and in
    // parallel, instead of one by one when they are selected.
    private preloadGoogleFiles(): void {
        this.files.filter((file) => this.isGoogleFile(file)).forEach((file) => this.fetchGoogleFile(file));
    }

    private fetchGoogleFile(file: any): void {
        const key = this.fileRef(file);
        if (this.googleBlobUrls.has(key) || this.googleLoading.has(key)) {
            return;
        }

        this.googleLoading.add(key);
        this.mainContentService.getGoogleFile(this.downloadId, key, 'View')
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.googleLoading.delete(key);
                    if (!response.body) {
                        this.cdr.detectChanges();
                        return;
                    }
                    const url = URL.createObjectURL(response.body);
                    this.googleBlobUrls.set(key, url);
                    this.googleFiles.set(key, {
                        blob: response.body,
                        name: this.fileNameFrom(response.headers.get('Content-Disposition'))
                    });
                    // Only show it if it is still the selected file
                    if (this.selectedFileKey === key) {
                        this.viewURL = url;
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    // Not cached, so selecting the file again retries it
                    this.googleLoading.delete(key);
                    this.handleFileError(error);
                    this.cdr.detectChanges();
                }
            });
    }

    isFileLoading(file: any): boolean {
        return this.googleLoading.has(this.fileRef(file));
    }

    isSelectedFileLoading(): boolean {
        return this.googleLoading.has(this.selectedFileKey);
    }

    downloadGoogleFile(file: any): void {
        const key = this.fileRef(file);
        if (this.downloading.has(key)) {
            return;
        }

        // Already loaded for the viewer: it is the same file, no need to request it again
        const loaded = this.googleFiles.get(key);
        if (loaded) {
            this.saveBlob(loaded.blob, loaded.name || file.name);
            return;
        }

        this.downloading.add(key);
        this.mainContentService.getGoogleFile(this.downloadId, key, 'Download')
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.downloading.delete(key);
                    if (response.body) {
                        const name = this.fileNameFrom(response.headers.get('Content-Disposition')) || file.name;
                        this.saveBlob(response.body, name);
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.downloading.delete(key);
                    this.handleFileError(error);
                    this.cdr.detectChanges();
                }
            });
    }

    isDownloading(file: any): boolean {
        return this.downloading.has(this.fileRef(file));
    }

    private saveBlob(blob: Blob, name: string): void {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
    }

    // The proxy answers 401 / 403 when the token has no access: same treatment as when loading the download.
    private handleFileError(error: any): void {
        console.error('Error loading file:', error);
        if (error.status === 401 || error.status === 403) {
            sessionStorage.removeItem('authToken');
            this.tokenError.emit({ status: error.status });
        }
    }

    private fileNameFrom(contentDisposition: string | null): string | null {
        if (!contentDisposition) return null;
        const encoded = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
        if (encoded) {
            try {
                return decodeURIComponent(encoded[1]);
            } catch {
                return null;
            }
        }
        const plain = /filename="([^"]+)"/i.exec(contentDisposition);
        return plain ? plain[1] : null;
    }

    private checkAllFilesViewed(): void {
        this.allFilesViewed = this.files.length > 0 && this.viewedFiles.size === this.files.length;
    }


    formatFileSize(bytes: string): string {
        const size = parseInt(bytes);
        if (isNaN(size)) return '0 B';
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.googleBlobUrls.forEach((url) => URL.revokeObjectURL(url));
        this.googleBlobUrls.clear();
        this.googleFiles.clear();
    }

    clear() {
        this.signaturePad.clear();
        this.cdr.detectChanges();
    }

    onSignatureChange(): void {
        this.cdr.detectChanges();
    }

    isSignEnabled(): boolean {
        if (!this.areButtonsEnabled()) return false;
        if (this.showSignaturePad) {
            return !this.isEmpty();
        }
        return true;
    }

    areButtonsEnabled(): boolean {
        if (this.isSubmitting) return false;
        if (this.device === 'mobile') {
            return !this.userSigned && this.type === SIGN_TYPE;
        }
        else {
            return (this.allFilesViewed && !this.userSigned && this.type === SIGN_TYPE && !this.isLoading);
        }
    }

    sign(): void {
        if (!this.allFilesViewed) {
            let message = this.translate.instant('You must view all documents before signing.');
            this.actionsService.set({
                type: 'notification',
                status: 'none',
                message: `⚠️ ${message}`
            });
            return;
        }

        if (this.signaturePad && !this.signaturePad.isEmpty()) {
            const signatureData = this.signaturePad.toDataURL();

            this.isSubmitting = true;
            this.mainContentService.sign(this.downloadId, signatureData, this.comment)
                .subscribe({
                    next: (response: any) => {
                        this.isSubmitting = false;
                        let message = this.translate.instant('Documents signed successfully.');
                        this.actionsService.set({
                            type: 'notification',
                            status: 'none',
                            message: `✅ ${message}`
                        });
                        this.signaturePad.clear();
                        this.comment = '';
                        this.showSignatureView = false;
                        this.loadFiles();
                    },
                    error: (error: any) => {
                        this.isSubmitting = false;
                        let message = this.translate.instant('Error signing documents.');
                        this.actionsService.set({
                            type: 'notification',
                            status: 'none',
                            message: `❌ ${message}`
                        });
                    }
                });
        }
    }


    isEmpty(): boolean {
        return !this.signaturePad || this.signaturePad.isEmpty();
    }

    accept(accepted: boolean): void {
        if (!this.allFilesViewed && this.device !== 'mobile') {
            let message = this.translate.instant('You must view all documents before signing.');
            this.actionsService.set({
                type: 'notification',
                status: 'none',
                message: `⚠️ ${message}`
            });
            return;
        }

        if (this.showSignaturePad && accepted) {
            this.sign();
            return;
        }

        let status = 'REJECTED';
        if (accepted) {
            status = 'ACCEPTED';
        }
        this.isSubmitting = true;
        this.mainContentService.accept(this.downloadId, status, this.comment)
            .subscribe({
                next: (response: any) => {
                    this.isSubmitting = false;
                    let message = this.translate.instant('Action performed successfully.');
                    this.actionsService.set({
                        type: 'notification',
                        status: 'none',
                        message: `✅ ${message}`
                    });
                    this.loadFiles();
                    this.signaturePad?.clear();
                    this.comment = '';
                },
                error: (error: any) => {
                    this.isSubmitting = false;
                    let message = this.translate.instant('Error signing documents.');
                    this.actionsService.set({
                        type: 'notification',
                        status: 'none',
                        message: `❌ ${message}`
                    });
                }
            });
    }



    private checkIfUserSigned(): void {
        if (this.accesses.length === 1) {
            const userAccess = this.accesses[0];
            this.userSigned = userAccess.status !== 'PENDING' && userAccess.status !== 'VIEWED';

            if (this.userSigned) {
                this.userStatus = userAccess.status;
                this.userSignatureDate = userAccess.date;
                this.userSignatureBase64 = userAccess.signatureBase64;
                this.userComment = userAccess.comment;
            }
        }
    }

    deleteElement(element: any, type: 'file' | 'access'): void {
        const confirmMessages = {
            file: 'Are you sure you want to delete this file?',
            access: 'Are you sure you want to remove this user?'
        };

        const successMessages = {
            file: 'File deleted successfully.',
            access: 'User removed successfully.'
        };

        const errorMessages = {
            file: 'Error deleting file.',
            access: 'Error removing user.'
        };

        const headerMessages = {
            file: 'Delete File',
            access: 'Remove User'
        };

        this.dialogService.confirm({
            title: this.translate.instant(headerMessages[type]),
            message: this.translate.instant(confirmMessages[type]),
            icon: type === 'file' ? 'delete' : 'person_remove'
        }).subscribe(confirmed => {
            if (confirmed) {
                this.mainContentService.deleteChild(parseInt(this.downloadId), element.id, type)
                    .subscribe({
                        next: () => {
                            let message = this.translate.instant(successMessages[type]);
                            this.actionsService.set({
                                type: 'notification',
                                status: 'none',
                                message: `✅ ${message}`
                            });
                            this.loadFiles();
                        },
                        error: (error: any) => {
                            let message = this.translate.instant(errorMessages[type]);
                            this.actionsService.set({
                                type: 'notification',
                                status: 'none',
                                message: `❌ ${message}`
                            });
                        }
                    });
            }
        });
    }
    canDeleteFiles(): boolean {
        return this.accesses.every(access => access.status === 'PENDING' || access.status === 'VIEWED');
    }

    canDeleteUser(access: any): boolean {
        return access.status === 'PENDING' || access.status === 'VIEWED';
    }
}
